export const Rocket = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_189_1428)">
        <path
          d="M7.5 14.4C8.1 13.5 8 12.6 7.8 11.9C9.1 11.3 10.2 10.5 11.2 9.79998C11.9 9.29998 12.7 8.69998 13.4 7.89998C14 7.19998 14.6 6.39998 15 5.59998C15.9 3.89998 16.2 2.09998 15.8 0.299976V0.199976H15.7C15.5 0.199976 15.1 0.0999756 14.9 0.0999756C14.4 0.0999756 13.9 0.0999756 13.3 0.0999756C12.3 0.199976 11.4 0.499976 10.5 0.899976C9.6 1.29998 8.8 1.89998 8.1 2.49998C7.4 3.19998 6.8 3.99998 6.2 4.69998C5.4 5.89998 4.7 6.99998 4.1 8.09998C3.9 8.09998 3.6 7.99998 3.3 7.99998C2.7 7.99998 2.1 8.19998 1.6 8.49998C0.9 8.89997 0 10.2 0 10.7C0 10.8 0.1 10.9 0.1 10.9C0.2 10.9 0.3 11 0.4 11C0.8 11 1.2 10.8 1.5 10.6C1.7 10.5 1.9 10.4 2 10.4H2.1C2.4 10.4 2.7 10.6 3 10.8C3 10.9 3 11 2.9 11.1C2.9 11.2 2.8 11.4 2.8 11.5V11.6C2.8 11.7 2.8 11.7 2.8 11.8C2.7 12 2.8 12.1 2.9 12.2C2.3 13 1.8 13.8 2 14H2.1C2.4 14 3 13.6 3.7 13.1C3.8 13.2 3.9 13.3 4 13.3H4.1C4.2 13.3 4.3 13.2 4.5 13.2C4.6 13.2 4.7 13.2 4.8 13.1C4.9 13 5.1 13 5.2 13C5.5 13.3 5.7 13.7 5.6 14.1C5.6 14.2 5.5 14.4 5.4 14.6C5.2 15 4.9 15.6 5.1 16C5.1 16.1 5.2 16.1 5.3 16.1C5.8 16 7.1 15.1 7.5 14.4Z"
          fill="url(#paint0_linear_189_1428)"
        />
        <path
          d="M8.7 7.3C9.2 7.7 9.8 8 10.5 8C11.2 8 11.8 7.7 12.3 7.3C13.3 6.3 13.3 4.8 12.3 3.8C11.8 3.3 11.1 3 10.5 3C9.8 3 9.2 3.3 8.7 3.8C8.3 4.2 8 4.8 8 5.5C8 6.2 8.3 6.8 8.7 7.3Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_189_1428"
          x1="0"
          y1="7.99758"
          x2="16"
          y2="7.99758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA3828" />
          <stop offset="1" stopColor="#AF2026" />
        </linearGradient>
        <clipPath id="clip0_189_1428">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
